import { Attributes, ModelBase, NeoModel, Rules, Validation } from "@singularsystems/neo-core";
import { TimeZoneFormat } from "@singularsystems/neo-core/dist/Misc";

@NeoModel
export default class SFTPBrokerDetailsLookup extends ModelBase {
    public staticServiceProviderSftpdetailsId: number = 0;

    public staticServiceProviderFileGroupingId: number = 0;

    public sftpDetailId: number = 0;

    public sftpSetting: string = "";

    public sftpDirectory: string = "";

    public isExportInd: boolean = false;

    @Attributes.Date(TimeZoneFormat.None)
    public nextRunDate: Date = new Date();

    public primeTimeCron: string = "";

    public lateCron: string = "";

    public isActiveInd: boolean = false;

    public isTradeOrder: boolean = false;

    public isValuation: boolean = false;
    
    public tradeSftpTypeId: number | null = null; 

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);

        rules.failWhen(r => r.isExportInd === false && (r.primeTimeCron === "" || r.primeTimeCron === null), "Please specify the prime time CRON.").onProperties(p => p.primeTimeCron);
        rules.failWhen(r => r.isExportInd === false && (r.lateCron === "" || r.lateCron === null) , "Please specify the late CRON.").onProperties(p => p.lateCron);
    }
}